import { Box, Button, Divider, Typography } from "@mui/material";
import styles from "./style.module.css";
import Top from "./top";
import Image from "./image";
import { useTheme } from "../../../../../../context/themeContext";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSwipeable } from "react-swipeable";
import { useDispatch, useSelector } from "react-redux";
import useDiscover from "../../../../../../hooks/useDiscover";
import { setFavorites } from "../../../../../../store/slices/profile/discoverSlice";

function Card({ project }) {
  const { theme, darkMode } = useTheme();
  const [showConfetti, setShowConfetti] = useState(false);
  const [liking, setLiking] = useState(null);
  const [isFavorite, setIsFavorite] = useState(project?.shout_outed);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { handleSwipeLeft, handleSwipeRight, insertShoutout, deleteShoutout } =
    useDiscover(true);
  const { removing, favorites } = useSelector((state) => state.discover);
  const user = useSelector((state) => state.user.value);

  const handleClick = () => {
    setShowConfetti(true);
  };

  useEffect(() => {
    let fav;
    favorites.map((item) =>
      item.receiver_id === project.matched_user_id
        ? (fav = true)
        : (fav = project.shout_outed)
    );
    setIsFavorite(fav);
  }, [project]);

  const removeFav = () => {
    setIsFavorite(false);
    deleteShoutout(project);
  };

  const AddFav = () => {
    setLiking(project);
    setIsFavorite(true);
    setTimeout(() => {
      dispatch(
        setFavorites([
          ...favorites,
          { sender_id: user.id, receiver_id: project.matched_user_id },
        ])
      );
      handleClick();
      setLiking(null);
      insertShoutout(project);
    }, 100);
  };

  const handlers = useSwipeable({
    onSwipedRight: () => {
      handleSwipeLeft(project);
      AddFav();
    },
    onSwipedLeft: () => handleSwipeRight(project),
  });

  return (
    <Box
      {...handlers}
      className={`${styles.card} ${
        removing === project ? styles.removing : ""
      } ${liking === project ? styles.liking : ""}`}
      sx={{
        bgcolor: darkMode ? theme.palette.lightgrey.lightgrey400 : "#FFF",
      }}
    >
      <Top
        project={project}
        isFavorite={isFavorite}
        setIsFavorite={setIsFavorite}
        AddFav={AddFav}
        removeFav={removeFav}
        showConfetti={showConfetti}
        setShowConfetti={setShowConfetti}
      />
      <Divider sx={{ width: "100%" }} />
      <Box className={styles.content}>
        <Image image={project.skill_cover_image} />
        <Box className={styles.text}>
          <Typography
            component="h4"
            variant="body1"
            sx={{
              fontSize: "20px",
              fontWeight: "500",
              color: theme.palette.darkgrey.darkgrey600,
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              WebkitLineClamp: 1,
              textOverflow: "ellipsis",
              minHeight: "1.5em",
              width: "100%",
            }}
          >
            {project?.tagline || ""}
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ width: "100%" }} />
      <Box className={styles.button}>
        <Button
          variant="contained"
          onClick={() => navigate(`/creators/${project?.user_id}`)}
          sx={{
            textTransform: "capitalize",
            flex: "1",
            p: "10px 1.5rem",
            borderRadius: "4px",
          }}
        >
          View Creator
        </Button>
      </Box>
    </Box>
  );
}

export default Card;
